import React, { useEffect, useState } from "react";
import "./NewPreviewUI.css";
import NewPreviewLeftSkeleton from "./NewPreviewLeftSkeleton";
import NewPreviewLeftCustomisationData from "./NewPreviewLeftCustomisationData";
import { useSelector } from "react-redux";
import EditSearchModal from "./EditSearchModal";
const NewPreviewLeftCustomisationList = ({
  errorGettingPreview,
  seterrorGettingPreview,
  editSearch,
  seteditSearch,
  setUseTemplateSelected,
  setshowmodel,
  setshowPreviewList,
  setGetExtendedResult,
  showPreviewListData,
  useTemplateSelected,
  customisationId,
  setCustomisationId,
  templateResults,
}) => {
  const [listofcustomisations, setlistofcustomisations] = useState(null);
  const previewCustomisations = useSelector(
    (state) => state?.previewCustomisations?.PreviewCustomisations
  );

  useEffect(() => {
    if (showPreviewListData != null) {
      setlistofcustomisations(showPreviewListData.customisations);
    }
    if (previewCustomisations && previewCustomisations.length > 0) {
      seteditSearch(false);
      setlistofcustomisations(previewCustomisations);
    }
  }, [showPreviewListData, previewCustomisations]);
  return !useTemplateSelected && errorGettingPreview ? (
    <EditSearchModal seteditSearch={seterrorGettingPreview} error={true} />
  ) : showPreviewListData == null ? (
    useTemplateSelected && templateResults != null ? (
      <NewPreviewLeftCustomisationData
        useTemplateSelected={useTemplateSelected}
        templateResults={templateResults}
        setUseTemplateSelected={setUseTemplateSelected}
        setshowPreviewList={setshowPreviewList}
      />
    ) : (
      <NewPreviewLeftSkeleton />
    )
  ) : (
    <NewPreviewLeftCustomisationData
      errorGettingPreview={errorGettingPreview}
      editSearch={editSearch}
      seteditSearch={seteditSearch}
      setshowmodel={setshowmodel}
      setUseTemplateSelected={setUseTemplateSelected}
      setshowPreviewList={setshowPreviewList}
      setGetExtendedResult={setGetExtendedResult}
      listofcustomisations={listofcustomisations}
      customisationId={customisationId}
      setCustomisationId={setCustomisationId}
    />
  );
};

export default NewPreviewLeftCustomisationList;
